<template>
  <div>
    <div class="add-company-content">
      <div class="form-section">
        <div class="form-title-section">
          <span class="form-title">Share a few information about your business.</span>
          <img src="../assets/images/add-company.svg">
        </div>
        <div class="form-panel" v-show="step == 1">Identity registration</div>
        <div class="form-panel" v-show="step == 2">Business details</div>
        <div class="form-panel" v-show="step == 3">Profile Customization</div>
        <div class="form-inputs" v-show="step == 1">
          <v-text-field v-model="company.name" :rules="nameRules" label="Name*" required></v-text-field>
          <v-text-field v-model="company.website" :rules="nameRules" label="Website" required></v-text-field>
          <v-select :items="items" label="Company type*" v-model="company.type"></v-select>
        </div>
        <div class="form-inputs" v-show="step == 2">
          <v-select :items="items" label="Industry*" v-model="company.industry"></v-select>
          <v-select :items="items" label="Company size" v-model="company.size"></v-select>
          <v-text-field :rules="nameRules" label="Email*" v-model="company.email"></v-text-field>
          <v-text-field :rules="nameRules" label="Location/Headquarter*" v-model="company.headquarter"></v-text-field>
        </div>
        <div class="form-inputs" v-show="step == 3">
          <span class="mt-2" style="color:#999999;">Logo</span>
          <v-divider></v-divider>
          <div class="img-section">
            <vue-dropzone
              ref="myVueDropzone"
              id="dropzone"
              :options="dropzoneOptions"
              :duplicateCheck = "true"
              @vdropzone-file-added = "addFile"
              class="mt-2 mb-2"
              useCustomSlot>
              <div class="dropzone-custom-content">
                <span class="dropzone-custom-title">
                  Drag and drop
                  to uploaddropzone-custom-content
                </span>
                <div class="subtitle">
                  <i class="material-icons">arrow_upward</i>
                </div>
              </div>
            </vue-dropzone>
            <div class="img-controls">
              <span>Upload file for preview</span>
              <span>300 x 300px recommended.</span>
              <span>JPGs, JPEGs, and PNGs supported.</span>
            </div>
          </div>
          <v-textarea outline name="input-7-4" label="Description" v-model="company.description"></v-textarea>
          <div class="tas">
            <v-checkbox v-model="company.agree"></v-checkbox>
            <span class="caption">
              I verify that I am an authorized representative of this organization and
              have the right to act on its behalf in the creation and management of this
              page. The organization and I agree to the additional terms for Pages.
            </span>
          </div>
          <div><button class="c-btn" :disabled="!company.agree" @click="saveCompany">Submit</button></div>
        </div>
        <div class="c-form-control">
          <div class="c-form-control-item" style="cursor:pointer;" v-on:click="prev()" v-show="step != 1">
            <i class="material-icons">keyboard_arrow_left</i>
            <span style="color:#006837;">Prev</span>
          </div>
          <div class="c-form-control-item" style="cursor:pointer;" v-on:click="next()" v-show="step != 3">
            <i class="material-icons">keyboard_arrow_right</i>
            <span style="color:#006837;">Next</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import imageCompression from 'browser-image-compression';

export default {
  name: "c-addcompany",
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      step: 1,
        options : {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: false,
        },
      company : {
          name: "",
          website: "",
          type : '',
          industry : '',
          headquarter : '',
          size : '',
          email : '',
          agree : false,
          description : '',
          logo : null
      },
      items: ["organisation", "business", "non-profit"],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" }
      }
    };
  },
  methods: {
    next() {
      return this.step < 3 ? this.step++ : null;
    },
    prev() {
      return this.step > 1 ? this.step-- : null;
    },
    saveCompany(){
        let vm = this
        let formData = new FormData();
        formData.append("name", this.company.name);
        formData.append("web_site", this.company.website);
        formData.append("type", this.company.type);
        formData.append("industry", this.company.industry);
        formData.append("headquarter", this.company.headquarter);
        formData.append("size", this.company.size);
        formData.append("description", this.company.description);
        imageCompression(this.company.logo, vm.options)
            .then(function (compressedFile) {
                formData.append("logo", compressedFile);
                console.log(compressedFile)
                vm.$store.dispatch("ADD_COMPANY", formData);
            })
            .catch(function (error) {
                console.log(error.message);
            });
        
    }   ,
    addFile(file){
         this.company.logo = file
    }
  },
  computed: {
    preImages() {
      return this.images.map(v => {
        return v.src;
      });
    }
  },
  watch: {},
  created() {}
};
</script>
<style scoped>
.add-company-content {
  display: grid;
  grid-template-columns: 5fr 5fr 1fr;
}
.form-section {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.form-title-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1rem;
}
.form-title {
  color: #006837;
  font-size: 1.5rem;
  margin-right: 0.3rem;
}
.form-panel {
  background-color: #d0debb;
  width: 90%;
  margin-top: 1rem;
  padding: 1rem;
}
.form-inputs {
  width: 90%;
  display: flex;
  flex-direction: column;
}
.c-form-control {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  margin-top: 2rem;
  width: 100%;
}
.tas {
  display: flex;
  flex-direction: row;
}
.dropzone {
  border-style: dashed;
  width: 50%;
}
.img-section {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.img-controls {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin-left: 0.5rem;
}
.c-btn {
  width: 8rem;
  color: white;
  background-color: #aaaa2d;
  cursor: pointer;
  padding: 0.3rem;
  border-radius: 5px;
  text-align: center;
}
.c-btn:disabled{
  background: #dddddd;
  cursor: default;
}
.c-form-control-item {
  display: flex;
  flex-direction: column;
}
</style>
